export default number => {
	if (typeof number === 'undefined') {
		return '';
	}

	const numbers = String(number).split('').reverse();
	const output = [];

	while(numbers.length > 0) {
		output.push(numbers.splice(0,3).reverse().join(''));
	}

	return output.reverse().join(' ');
}
